import React from 'react';
import ReactModal from 'react-modal';

import { CircularProgress } from '@mui/material';

/*
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
	root: {},
}));
*/

function InProcModal({ isOpen, ...rest }) {
	//const classes = useStyles();

	return (
		<ReactModal
			isOpen={isOpen}
			ariaHideApp={false}
			style={{
				content: {
					left: '50%', top: '50%', right: 'auto', bottom: 'auto',
					marginRight: '-50%', transform: 'translate(-50%, -50%)',
					borderWidth: 0
				}
			}}>
			<CircularProgress color="secondary" />
		</ReactModal>
	);
}

export default InProcModal;
